<template>
  <div :class="['bg-linear-to-r from-secondary from-75% to-secondary/40 to-100%']">
    <!-- 按钮组容器 -->
    <div
      :class="[
        'page_view',
        'lg:h-14 h-10',
        'flex items-center justify-start lg:gap-x-8 gap-x-6',
        'overflow-x-auto',
      ]"
    >
      <!-- 单按钮 -->
      <div
        v-for="(item, index) in props.list"
        :key="`group-menu-${item.label}-${index}`"
        :class="[
          'h-full',
          'flex items-center justify-center',
          'hover:cursor-pointer',
          'lg:text-lg text-md text-white font-bold text-nowrap',
          // 悬浮时的下划线
          'hover:border-b-6 border-primary',
          // 处于活跃状态的菜单下划线
          {
            'border-b-6 border-primary':
              item.value && withoutTrailingSlash(route.path) === localePath(item.value),
          },
        ]"
        @click="item.value && useLocalePush(item.value)"
      >
        <p v-if="item.label" class="lg:min-w-20 min-w-14 text-center">
          {{ t(item.label) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { AppComponentItem } from '~/types/common/item'
  import { withoutTrailingSlash } from 'ufo'

  const { t } = useI18n()
  const route = useRoute()
  const localePath = useLocalePath()

  interface GroupMenuList {
    list: AppComponentItem[]
  }

  const props = withDefaults(defineProps<GroupMenuList>(), {})
</script>
